module.exports = __webpack_public_path__ + "img/CompScope_Mag_2_Focus_1.4ad9c14a.png";